export default {
  metadata: {
    version: '1.0.0',
    id: 'dropdown-menu-1.0.0',
    name: 'JDSDropdownMenu'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_dropdown_menu_internal']
      }
    ]
  },
  base: {
    popup: {
      priority: 60,
      'background-color': '{global.transparent}',
      hidden: true
    },
    'popup-container': {
      hidden: false
    },
    jds_dropdown_menu_internal: {
      hidden: false,
      kind: 'single-select'
    }
  },
  variant: {
    kind: {
      'multi-select': {
        jds_dropdown_menu_internal: {
          kind: 'multi-select',
          showCTAButtons: true
        }
      }
    },
    _menuFullScreen: {
      true: {
        'popup-container': {
          size: '{size.max}'
        },
        jds_dropdown_menu_internal: {
          menuFullScreen: true
        }
      }
    },
    open: {
      true: {
        popup: {
          hidden: false
        },
        jds_dropdown_menu_internal: {
          open: true
        }
      }
    },
    searchTrigger: {
      true: {
        jds_dropdown_menu_internal: {
          searchTrigger: true
        }
      }
    },
    showCTAButtons: {
      false: {
        jds_dropdown_menu_internal: {
          showCTAButtons: false
        }
      }
    },
    labelTextWrap: {
      true: {
        jds_dropdown_menu_internal: {
          labelTextWrap: true
        }
      }
    },
    width: {
      trigger: {
        jds_dropdown_menu_internal: {
          menuWidthConfig: 'trigger'
        }
      }
    },
    position: {
      bottom_start: {
        jds_dropdown_menu_internal: {
          position: 'bottom_start'
        }
      },
      bottom_end: {
        jds_dropdown_menu_internal: {
          position: 'bottom_end'
        }
      },
      top_start: {
        jds_dropdown_menu_internal: {
          position: 'top_start'
        }
      },
      top_end: {
        jds_dropdown_menu_internal: {
          position: 'top_end'
        }
      },
      right_start: {
        jds_dropdown_menu_internal: {
          position: 'right_start'
        }
      },
      right_end: {
        jds_dropdown_menu_internal: {
          position: 'right_end'
        }
      },
      left_start: {
        jds_dropdown_menu_internal: {
          position: 'left_start'
        }
      },
      left_end: {
        jds_dropdown_menu_internal: {
          position: 'left_end'
        }
      },
      bottom_centre: {
        jds_dropdown_menu_internal: {
          position: 'bottom_centre'
        }
      },
      top_centre: {
        jds_dropdown_menu_internal: {
          position: 'top_centre'
        }
      }
    }
  },
  api: {
    events: {
      jds_dropdown_menu_internal: {
        onSuffixClick: 'onSuffixClick',
        onSearchChange: 'onSearchChange',
        onAppear: {
          name: '_onAppear',
          platform: 'ios'
        },
        onContainerClick: '_onContainerClick',
        onPrimaryClick: 'onPrimaryClick',
        onSecondaryClick: 'onSecondaryClick'
      },
      popup: {
        onClick: 'onClose'
      }
    },
    data: {
      jds_dropdown_menu_internal: {
        searchLabel: {
          type: 'string',
          name: 'searchLabel'
        },
        searchValue: {
          type: 'string',
          name: 'searchValue'
        },
        searchSuffix: {
          type: 'icon',
          name: 'searchSuffix'
        },
        menuWidth: {
          type: 'size',
          name: '_menuWidth'
        },
        triggerRef: {
          type: 'ref',
          name: 'triggerRef'
        },
        menuMaxHeight: {
          type: 'string',
          name: '_menuMaxHeight'
        },
        primaryCTA: {
          type: 'string',
          name: 'primaryCTA'
        },
        secondaryCTA: {
          type: 'string',
          name: 'secondaryCTA'
        },
        children: {
          name: 'children',
          type: 'slot',
          accepts: ['jds_dropdown_menu_group']
        }
      },
      'popup-container': {
        'padding-left': {
          type: 'size',
          name: 'offsetX'
        },
        'padding-top': {
          type: 'size',
          name: 'offsetY'
        }
      }
    },
    config: {
      kind: {
        values: ['single-select', 'multi-select']
      },
      searchTrigger: {
        values: [false, true]
      },
      showCTAButtons: {
        values: [true, false]
      },
      labelTextWrap: {
        values: [false, true]
      },
      open: {
        values: [false, true]
      },
      width: {
        values: ['max-content', 'trigger']
      },
      position: {
        values: [
          'bottom_start',
          'bottom_end',
          'top_start',
          'top_end',
          'right_start',
          'right_end',
          'left_start',
          'left_end',
          'bottom_centre',
          'top_centre'
        ]
      },
      _menuFullScreen: {
        values: [false, true]
      }
    },
    a11y: {
      jds_dropdown_menu_internal: {
        properties: {
          searchAriaLabel: 'searchAriaLabel'
        }
      }
    }
  }
};
